import {
    createListTableColumns,
    ListTableColumn,
    renderDate,
    renderOptionalTextWithTooltip,
    renderTextWithTooltip
} from "sprint-common-web";

import { renderActionStatus } from "../../../../common/utils/renderActionStatus";
import { ProcessRejectFileRecordListingItem } from "./RejectFileRecordListingItem";

export const createRejectFileRecordListingColumns = (): ListTableColumn<ProcessRejectFileRecordListingItem>[] => {
    return createListTableColumns<ProcessRejectFileRecordListingItem>([
        {
            type: "basic",
            key: "filename",
            name: "Delivery file name",
            minWidth: 100,
            maxWidth: 180,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "filePath",
            name: "File path",
            minWidth: 100,
            maxWidth: 220,
            onRender: renderOptionalTextWithTooltip
        },
        {
            type: "basic",
            key: "reference",
            name: "Reference",
            minWidth: 70
        },
        {
            type: "basic",
            key: "originator",
            name: "Originator",
            minWidth: 200,
            maxWidth: 180
        },
        {
            type: "basic",
            key: "arrivalDate",
            name: "Arrival date",
            minWidth: 120,
            maxWidth: 120,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            onRender: renderActionStatus
        }
    ]);
};
